
import { templateJitUrl } from '@angular/compiler';
import { AfterViewInit, Component, ElementRef, ViewChild, Input, OnInit } from '@angular/core';
import { DashboardService } from '@app/_services/dashboard.service';
import { first } from 'rxjs/operators';

declare var google: any;

@Component({
    selector: 'app-bar-chart-monthly',
    template: `<div #chartDiv  id="initial_chart_div" style="width: 100%; height: 100%;" ></div>`
})
export class BarChartMonthlyComponent implements OnInit {
    name = 'Angular';
    getPerformanceGraphMonthly: any;
    currentyear = (new Date()).getFullYear();
    @ViewChild('chartDiv') pieChart: ElementRef
    constructor(private dashboardService: DashboardService) { }
    yr: any;
    @Input() set countMonthly(countMonthly: number) {
        this.yr = countMonthly;
        google.charts.load('current', { 'packages': ['bar'] });
        var data1 = [];
        if(this.yr!=undefined)
        {
        var v = this.dashboardService.getPerformanceGraphMonthly(this.yr)
            .pipe(first())
            .subscribe(
                data => {
                    console.log("getPerformanceGraphMonthly response---", data)
                    this.getPerformanceGraphMonthly = data.respData;
                    if (data.respData.length > 0) {
                        var Header = [];
                        Header.push('Name');
                        for (var i = 0; i < data.respData.length; i++) {
                            Header.push(data.respData[i].fullNm);
                        }
                        data1.push(Header);
                        var temp = []; temp.push('');
                        for (var i = 0; i < data.respData.length; i++) {

                            // temp.push(data.respData[i].fullNm);
                            temp.push(data.respData[i].count);

                        }
                        data1.push(temp);

                        var data = new google.visualization.arrayToDataTable(data1);
                        const options = {
                            
                            height: 200,
                            isStacked: false,
                            vAxis: { format: 'decimal'},
                            hAxis: { format: 'none' ,
                            textStyle : {
                                fontSize : 0
                            }},
                            series: {
                                0: { color: '#fdd835' },
                                1: { color: '#0091ff' },
                                2: { color: '#e53935' },
                                3: { color: '#43a047' },
                            }
                        }

                        const chart = new google.charts.Bar(document.querySelector('#initial_chart_div'));
                        chart.draw(data, google.charts.Bar.convertOptions(options));

                    }
                    else
                    {

                        var Header1 = ['Name', 'Density'];
                        data1.push(Header1);
                        var data = new google.visualization.arrayToDataTable(data1);
                        const options = {
                            height: 200,
                            isStacked: false,
                            vAxis: { format: 'decimal' },
                            hAxis: { 
                                hAxis: { textPosition: 'none' },format: '' ,
                                textStyle : {
                                    fontSize : 0
                                }},
                            series: {
                                0: { color: '#fdd835' },
                                1: { color: '#0091ff' },
                                2: { color: '#e53935' },
                                3: { color: '#43a047' },
                            }
                        }
                        const chart = new google.charts.Bar(document.querySelector('#initial_chart_div'));
                        chart.draw(data, google.charts.Bar.convertOptions(options));
                    }
                },
                error => {
                    console.log(error)
                })
            }
    }

    ngOnInit() {
        var currentMonth = (new Date()).getMonth() + 1;
        var d = currentMonth + '/' + this.currentyear;
        this.drawChart(d);
    }

    drawChart(datef) {
        google.charts.load('current', { 'packages': ['bar'] });
        google.charts.setOnLoadCallback(drawChart);
        var data1 = [];
        var v = this.dashboardService.getPerformanceGraphMonthly(datef)
            .pipe(first())
            .subscribe(
                data => {
                    console.log("getPerformanceGraphMonthly response---", data)
                    this.getPerformanceGraphMonthly = data.respData;
                   {
                    var Header = [];
                    Header.push('Name');
                    for (var i = 0; i < data.respData.length; i++) {
                        Header.push(data.respData[i].fullNm);
                    }
                    data1.push(Header);
                    var temp = []; temp.push('');
                    for (var i = 0; i < data.respData.length; i++) {

                        // temp.push(data.respData[i].fullNm);
                        temp.push(data.respData[i].count);

                    }
                    data1.push(temp);
                    var data = new google.visualization.arrayToDataTable(data1);
                    const options = {
                        
                        height: 200,
                        isStacked: false,
                        vAxis: { format: 'decimal'},
                        hAxis: { format: 'none' ,
                        textStyle : {
                            fontSize : 0
                        }},
                        series: {
                            0: { color: '#fdd835' },
                            1: { color: '#0091ff' },
                            2: { color: '#e53935' },
                            3: { color: '#43a047' },
                        }
                    }

                    const chart = new google.charts.Bar(document.querySelector('#initial_chart_div'));
                    chart.draw(data, google.charts.Bar.convertOptions(options));

                }
               
                },
                error => {
                    console.log(error)
                })


        function drawChart() {

            if(data1.length>0)
            {
            var data = new google.visualization.arrayToDataTable(data1);
            const options = {
                legend: { position: 'top' },
                height: 200,
                isStacked: false,
                barChartLegend: false,
                vAxis: { format: 'decimal' },
                hAxis: { format: '' ,
                textStyle : {
                    fontSize : 0
                }},
                series: {
                    0: { color: '#fdd835' },
                    1: { color: '#0091ff' },
                    2: { color: '#e53935' },
                    3: { color: '#43a047' },
                }
            };
            const chart = new google.charts.Bar(document.querySelector('#initial_chart_div'));
            chart.draw(data, google.charts.Bar.convertOptions(options));}
        }
    }
}
